import { defineStore } from 'pinia'
import { resolveRegionId } from '../constants'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    seller: null,
    token: null,
    isAuthenticated: false,
    initialized: false
  }),

  getters: {
    sellerId: (state) => state.seller?.id,
    regionId: (state) => resolveRegionId(state.seller?.regionId, state.seller?.RegionId),
  },

  actions: {
    login(seller, token) {
      this.seller = seller
      this.token = token
      this.isAuthenticated = true
      
      localStorage.setItem('seller', JSON.stringify(seller))
      localStorage.setItem('authToken', token)
      const regionId = resolveRegionId(seller?.regionId, seller?.RegionId)
      if (regionId) localStorage.setItem('regionId', regionId)
    },

    logout() {
      this.seller = null
      this.token = null
      this.isAuthenticated = false
      
      localStorage.removeItem('seller')
      localStorage.removeItem('authToken')
      localStorage.removeItem('regionId')
    },

    initialize() {
      if (this.initialized) return
      
      const seller = localStorage.getItem('seller')
      const token = localStorage.getItem('authToken')
      
      if (seller && token) {
        try {
          this.seller = JSON.parse(seller)
          this.token = token
          this.isAuthenticated = true
        } catch (e) {
          console.error('Erro ao inicializar auth store:', e)
        }
      }
      
      this.initialized = true
    }
  }
})

